import {ImapConfiguration} from '@app/_components/imap-configuration/imap-configuration';

export class Msg {
  msgId: number;
  createDate: Date;
  lastUpdate: Date;
  sentDate: Date;
  receivedDate: Date;
  senderName: string;
  senderEmail: string;
  senderMobileNum: string;
  senderCountryCode: string;
  subject: string;
  preheader: string;
  emailHtml: string;
  emailText: string;
  mobileText: string;
  headers: string;
  status: number;
  statusMsg: string;
  confId: string;
  trackingId: string;
  opsNotes: string;
  msgCampaignAPI: any;
  msgRecipientAPIList: any[];
  topic: number;
  topicPurpose: number;
  topicId: number;
  taskAPI: any;
  msgFolder: number;
  taskAPIList: any[];
  attachments: any[];
  imapConfigurationAPI: ImapConfiguration;
}
